/** @format */

import React, { useState, useEffect } from "react";
import { Layout, Row, Col } from "antd";
import Link from "next/link";
import { footerNavigation, socialMediaClicks } from "../../utils/GTMDataLayer";
import { enquireScreen } from "enquire-js";
import { footerNav, footerSocialNav, footerText } from "./Footer.helper";
import module_style from "./Footer.module.css";

const { Footer: AntFooter } = Layout;

function Footer() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    enquireScreen((status) => setIsMobile(status));
  }, []);

  return (
    <AntFooter className={`${module_style.container} footer dark style-v2`}>
      <Row className={module_style.nav_container} gutter={[16, 16]}>
        {/* Navigation Links */}
        <Col xs={24} md={19}>
          <Row
            gutter={[16, 16]}
            className={`${module_style.nav_container_col} ${module_style.nav_links_wrapper}`}
          >
            {footerNav.map((nav) => (
              <Col key={nav.link} xs="auto" style={{ flex: "0 0 auto" }}>
                <nav className={`${module_style.link} small-link`}>
                  <Link
                    href={nav.link}
                    prefetch={false}
                    onClick={() => footerNavigation("", nav.gtmLabel)}
                    target={
                      nav.target === "_blank" && isMobile ? "_self" : "_blank"
                    }
                  >
                    {nav.label}
                  </Link>
                </nav>
              </Col>
            ))}
          </Row>
        </Col>

        {/* Social Icons */}
        <Col xs={24} md={5} className={module_style.social_link_container}>
          {footerSocialNav.map((socialNav) => (
            <span key={socialNav.label}>
              <a
                href={socialNav.link}
                target={socialNav.target}
                onClick={() =>
                  socialMediaClicks(socialNav.gtmLabel, "footer")
                }
                title={socialNav.label}
              >
                {socialNav.icon}
              </a>
            </span>
          ))}
        </Col>
      </Row>

      {/* Footer Text */}
      <div className={module_style.text}>
        <small>{footerText}</small>
      </div>
    </AntFooter>
  );
}

export default Footer;
